var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyProfilImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-6587.61,-948)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.503937,0,0,0.571731,5702.11,467.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Users-Profil",
    serifId: "Users Profil",
    transform: "matrix(2.38125,0,0,2.09889,590.339,462.565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515,180C501.2,180 490,191.2 490,205C490,218.8 501.2,230 515,230C528.8,230 540,218.8 540,205C540,191.2 528.8,180 515,180ZM530.269,222.199C535.012,217.985 538,211.841 538,205C538,192.3 527.7,182 515,182C502.3,182 492,192.3 492,205C492,211.841 494.988,217.985 499.731,222.199C502.446,222.115 506.159,222.8 509.516,219.025C510.498,217.921 510.292,214.903 510,214C508.819,213.419 508.056,211.685 508,208C506.902,208.017 506.198,207.629 506,207C505.29,204.738 504.383,202.338 506,200C503.819,191.728 509,187 515,187C521,187 526.181,191.728 524,200C525.617,202.338 524.71,204.738 524,207C523.802,207.629 523.098,208.017 522,208C521.944,211.685 521.181,213.419 520,214C519.708,214.903 519.502,217.921 520.484,219.025C523.841,222.8 527.554,222.115 530.269,222.199Z",
    style: {
      fill: "rgb(33,46,68)"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProfilImg);
export default __webpack_public_path__ + "static/media/empty_profil_img.6e3c3a56efacf1ea9b9df61c529c0e17.svg";
export { ForwardRef as ReactComponent };